// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"0fe49d93","453":"6ca1120a","796":"d87d11e0"}[chunkId] + ".chunk.js";
};